<template>
  <div v-if="$root.globalData" class="target w margin drRtl">
    <div class="target__title">
      <!-- <img src="" alt="" /> -->
      <h3>{{ $root.globalData.keys.goals_title }}</h3>
      <p>{{ $root.globalData.keys.goals_description }}</p>
    </div>

    <div class="target__box">
      <div  class="boxes">
        <Boxsvg1 />
        <h4>{{ $root.globalData.keys.goal_1_title }}</h4>
        <p>{{ $root.globalData.keys.goal_1_text}}</p>
      </div>
      
      <div  class="boxes">
        <Boxsvg2  />
        <h4>{{ $root.globalData.keys.goal_2_title }}</h4>
        <p>{{ $root.globalData.keys.goal_2_text}}</p>
      </div>
      
      <div  class="boxes">
        <Boxsvg3  />
        <h4>{{ $root.globalData.keys.goal_3_title }}</h4>
        <p>{{ $root.globalData.keys.goal_3_text}}</p>
      </div>
      
    </div>
  </div>
</template>


<script>
import Boxsvg1 from "../svgs/boxsvg1.vue";
import Boxsvg2 from "../svgs/boxsvg2.vue";
import Boxsvg3 from "../svgs/boxsvg3.vue";

export default {
  data() {
    return {
             targetTitle: " !هدف  اینیاب",
          targetText: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم",
      boxes: [
        {
     
          boxTitle: "هدف اینیاب",
          boxdesc:
            " اگر شما یک طراح هستین و یا با طراحی های گرافیکی سروکار دارید به متن های برخورده اید که با نام لورم ایپسوم شناخته می‌شوند. لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) متنی ساختگی و بدون معنی است  ",
            icon: Boxsvg1
        },
        {
          targetTitle: " !هدف  اینیاب",
          targetText: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم",
          boxTitle: "هدف اینیاب",
          boxdesc:
            " اگر شما یک طراح هستین و یا با طراحی های گرافیکی سروکار دارید به متن های برخورده اید که با نام لورم ایپسوم شناخته می‌شوند. لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) متنی ساختگی و بدون معنی است  ",
            icon: Boxsvg2
        },
        {
          targetTitle: " !هدف اینیاب",
          targetText: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم",
          boxTitle: "هدف اینیاب",
          boxdesc:
            " اگر شما یک طراح هستین و یا با طراحی های گرافیکی سروکار دارید به متن های برخورده اید که با نام لورم ایپسوم شناخته می‌شوند. لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) متنی ساختگی و بدون معنی است  ",
            icon: Boxsvg3
        },
      ],
    };
  },

  components: { Boxsvg1, Boxsvg2, Boxsvg3 },
};
</script>
<style>
.ltrStyle .target h3,
.ltrStyle .target p{
  direction: ltr;
}
</style>
<style scoped>

.target {
  margin-bottom: 4rem;
}

.target h3 {
  font-weight: bolder;
  font-size: 30px;
  font-weight: bolder;
}

.target p {
  margin-top: 1rem;
}

.target__box {
  width: 100%;
  background-image: url(../../assets/images/targetb.png);
  background-repeat: no-repeat;
  background-size: 60%;
  background-position: center;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}
@media (max-width:768px){
  .target__box{
    display: flex;
  background-size: 100%;

  }
  
.boxes {
  padding: 0rem !important;
}
}
.target__box img {
  width: 100%;
  height: 100%;
}

.boxes {
  padding: 3rem;
}

.boxes h4 {
}

.boxes p {
  font-size: 13px;
  line-height: 2;
  color: #666;
}


</style>